var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestopsHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#313B58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8125 14.75L22 13.25V10.25C22 10.125 21.875 10 21.75 10H20.75C20.5938 10.0312 20.5 10.125 20.5 10.25V12.0312L16.0938 8.40625C15.8438 8.1875 15.3438 8.03125 15 8.03125C14.625 8.03125 14.125 8.1875 13.875 8.40625L6.15625 14.75C6.0625 14.8438 6 15 6 15.125C6 15.2188 6.03125 15.375 6.09375 15.4375L6.4375 15.8438C6.5 15.9375 6.6875 16 6.8125 16C6.90625 16 7.0625 15.9688 7.125 15.9062L8 15.1875V21C8 21.5625 8.4375 22 9 22H13C13.5312 22 13.9688 21.5625 14 21V17.75H16V21C16 21.5625 16.4375 22 17 22H21C21.5312 22 21.9688 21.5625 22 21.0312V15.1875L22.8438 15.9062C22.9062 15.9688 23.0625 16.0312 23.1562 16.0312C23.2812 16.0312 23.4688 15.9375 23.5625 15.8438L23.875 15.4375C23.9375 15.375 24 15.2188 24 15.125C24 15 23.9062 14.8438 23.8125 14.75ZM20.4688 20.5H17.5V17.25C17.4688 16.7188 17.0312 16.2812 16.5 16.25H13.5C12.9375 16.2812 12.5 16.7188 12.5 17.25V20.5H9.5V13.9688L15 9.4375L20.5 13.9688L20.4688 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestopsHome);
export default __webpack_public_path__ + "static/media/testops-home.bea7429221694c649f0fcfc9cfc7a0ee.svg";
export { ForwardRef as ReactComponent };